<template>
  <ion-page>
    <master-layout pageTitle="پرداخت">

          <Loading :is="!orderLoaded" v-if="!orderLoaded"></Loading>
          <div v-if="orderLoaded">
            <div v-if="order">
              <div v-if="order.status === 101 || order.status === 102 || order.status === 21">
                <ion-card>
                  <ion-card-content>

                <div class="center">
                  <div class="mr-auto ml-auto mb-4">
                    <img src="/assets/img/pre_order.png">
                  </div>
                  <h5>سفارش شما ثبت شد. <i class="fal fa-file-check"></i></h5>
                  <div class="mt-2">شماره سفارش :
                    {{ order.order_number }}
                  </div>
                  <div class="mt-2">درخواست شما توسط کارشناسان ما بررسی و طی 24 ساعت آینده از طریق پیامک به شما اطلاع
                    رسانی می شود.
                  </div>
                  <router-link :to="'/shop/preOrder/Info/'+order._id">
                    <ion-button expand="full" color="secondary">مشاهده اطلاعات سفارش</ion-button>
                  </router-link>
                </div>
                  </ion-card-content>
                </ion-card>
              </div>
              <div v-else>
                <h4>آیتم های سفارش</h4>
                <div id="plans-list">
                  <div v-for="item in orderItems" :key="item._id" class="brand-model-item item">
                    <div class="thumbnail">
                      <img :src="item.thumbnail_url"/>
                    </div>
                    <div class="title">
                      <h4>{{ item.item_title }}</h4>
                      <div class="c-attr">{{item.attr_string}}</div>
                    </div>
                    <div v-if="item.provider_id">
                      <div class="mb-1">
                        <i class="far fa-store"></i>
                        {{item.provider_title}}
                      </div>
                    </div>
                    <div class="justify-between mb-1 quantity">
                      <div> تعداد :</div>
                      <div>{{item.quantity}}</div>
                    </div>
                    <div class="price">
                        <div class="justify-between mb-1">
                          <div>قیمت :</div>
                          <div>
                            <div v-if="item.special_discount">
                              <del><money :number="item.original_price"></money></del>
                            </div>
                            <money :number="item.price"></money>
                            تومان
                          </div>
                        </div>
                        <div class="justify-between mb-1">
                          <div>جمع :</div>
                          <div>
                            <money :number="item.total"></money>
                            تومان
                          </div>
                        </div>


                    </div>
                    <div class="justify-between">
                      <div v-if="item.unit_type === 'big'" class=" text-danger">
                        واحد :
                        {{item.bigger_unit_title}}
                      </div>
                      <div v-if="item.unit_type === 'big'" class=" text-danger">
                        تعداد در هر {{item.bigger_unit_title}} :
                        {{item.bigger_unit_quantity}}
                      </div>
                    </div>
                  </div>
                </div>

                <ion-card>
                  <ion-card-header>
                    <ion-card-title>اطلاعات کلی</ion-card-title>
                  </ion-card-header>
                  <ion-card-content>
                    <div class="info-items">
                      <div>شماره سفارش :</div>
                      <div>
                        {{ order.order_number }}
                      </div>
                    </div>
                    <div class="info-items">
                      <div>جمع کل خرید شما :</div>
                      <div>
                        <money :number="order.subtotal"></money>
                        تومان
                      </div>
                    </div>
                    <div class="info-items">
                      <div>هزینه ارسال :</div>
                      <div>
                        <!--              <money :number="sendCost"></money>-->
                        <money :number="order.shipping_cost"></money>
                        تومان</div>
                    </div>
                    <div class="info-items text-success">
                      <div>مبلغ قابل پرداخت :</div>
                      <div><money :number="order.total"></money>
                        تومان</div>
                    </div>
                    <div class="info-items text-danger">
                      <div>سود شما از خرید :</div>
                      <div><money :number="order.special_discount_total"></money>
                        تومان</div>
                    </div>
                    <div v-if="balance">موجودی کیف پول :
                    <money :number="balance"></money> تومان
                    </div>
                    <div v-else>موجودی کیف پول :
                      <money number="0"></money> تومان
                    </div>
                    <ion-button @click="payOrderByBalance" v-if="balance >0 && balance > order.remaining_payment_amount" expand="full" color="success">
                      پرداخت سفارش از کیف پول
                    </ion-button>
                    <ion-button @click="openChargeApi" v-else expand="full" color="success">
                      شارژ مبلغ
                      <money :number="(order.remaining_payment_amount - balance)"></money>
                      کیف پول
                    </ion-button>
                  </ion-card-content>
                </ion-card>
              </div>
            </div>
            <div v-if="error" class="alert alert-danger">
              {{ error }}
            </div>
          </div>
    </master-layout>
  </ion-page>
</template>

<script>
import {mapActions} from "vuex";
import {IonPage, IonCard, IonCardContent, IonCardHeader} from '@ionic/vue';
import AjaxForm from "@/components/AjaxForm";
import Money from "@/components/Money";
import {openWebpage, showSystemNoti} from "@/shared/helper";

// import {getFormData} from '@/shared/helper'

export default {
  components: {
    AjaxForm,Money,
    IonPage, IonCard, IonCardContent, IonCardHeader
  },
  data()
  {
    return {
      id: null,
      orderLoaded: false,
      order: null,
      orderItems : [],
      isPreOrder : false,
      balance : 0,
      status : 0,
      error: null,
    }
  },
  async created()
  {
    await this.init();
  },
  methods: {
    openChargeApi()
    {
      const amount = this.order.remaining_payment_amount - this.balance;
      const url = process.env.VUE_APP_API_URL + process.env.VUE_APP_API_PATH + 'Charge/'+this.order.client_id+'/'+amount;
      openWebpage(url);
    },
    ...mapActions("shop", {
      getOrder: 'getOrder',
      payShopOrderByBalance : 'payShopOrderByBalance'
    }),
    async init()
    {
      this.order = null;
      this.orderLoaded = false;
      this.balance = 0;
      this.orderItems = [];
      this.isPreOrder = false;
      const self = this;
      this.id = this.$route.params.id;
      const result = await this.getOrder(this.id);
      if (result)
      {
        if (result.ok)
        {
          this.orderLoaded = true;
          this.order = result.order;
          this.balance = result.balance;
          this.orderItems = result.order_items;
          this.isPreOrder = this.order.is_pre_order;
          if (this.order.status !== 0 && this.order.status !== 101)
            self.$router.push({path : '/shopOrder/View/'+this.order._id});
        }
        else
        {
          this.orderLoaded = true;
          this.error = result.error
        }
      }
      else
      {
        this.orderLoaded = true;
        this.error = 'خطا در برقراری ارتباط با سرور'
      }
    },
    async payOrderByBalance()
    {
      const self = this;
      const check = await this.payShopOrderByBalance(this.order._id);
      if (check.ok)
      {
        self.$router.push({path : '/shopOrder/View/'+this.order._id});
      }
      else
        return showSystemNoti('danger',check.error);
    }
  },
  watch: {
    "$route.path": {
      handler(newUrl)
      {
        if (newUrl.toLowerCase().indexOf('payment/') >= 0)
        {
          this.init()
        }
      },
      deep:true
    },
  }
}

</script>

<style scoped>
.info-items{
  display: flex;
  justify-content: space-between;
  padding: 9px 0;
  border-bottom: 1px solid #c0c0c091;
}
#plans-list {
  overflow-x: auto;
  padding: 15px 5px;
  display: flex;
  flex-direction: row;
}
.brand-model-item {
  display: block;
  height: 450px;
  margin-left: 15px;
  width: 100%;
  min-width: 250px;
}
.thumbnail{
  height: 186px;
}
.thumbnail img {
  height: 180px;
  margin: 0 auto;
}
.brand-model-item > *{
  max-width: 100%;
}
.title h4 {
  color: #172e79;
  font-size: 20px !important;
  font-weight: bold;
  margin-top: 5px;
  margin-bottom: 5px;
  white-space: break-spaces;
}
.price del {
  display: inline;
  color: red;
}
.price div {
  display: block;
  color: #222222;
}
.price {
  height: 85px;
  font-size: 15px;
}
.c-attr {
  height: 27px;
  font-size: 15px;
}
.justify-between
{
  display: flex !important;
  justify-content: space-between;
}
.percent {
  background: #eb445a;
  color: white;
  font-size: 12px;
  border-radius: 4px;
  margin-left: 3px;
}
.quantity
{
  font-size: 15px;
  margin-bottom: 5px;
}
</style>